import {Part} from "./part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {floorThumbnail} from "../assets";

import {IntermediatePart} from "./intermediatePart";

export default class Floor extends Part {
  static id = 'Floor';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.partId = 'bathroom_floor';
    this.menuType = PartMenuType.Complex;
    this.partName = 'Floor';
    this.homePageTitle = 'Flooring';
    this.translateId = "visualizer.bathroom.floor";
    this.partThumbnail = floorThumbnail;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Floor":
        relatedItemName = "floorBody";
        RelatedItemClass = FloorBody;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Floor', this)
  }

  setLayers(layout, placeholdersNeeded) {
    const layers = [];
    this.getRelatedItems().forEach(relatedItem => {
      relatedItem.setLayers(layout);
      (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
        ? relatedItem.placeholderFeature.layer.addTo(layers)
        : relatedItem.activeFeature && relatedItem.activeFeature.layer.addTo(layers)
    });

    return layers;
  }
}

class FloorBody extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.isStoneFeature = true;
    this.partId = 'bathroom_floor';
    this.partName = 'Floor';
    this.translateId = "visualizer.bathroom.floor";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new FloorBody());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Floor;
    }
  }
}
